import { BiWifiOff, BiWifi, BiSignal5, BiNetworkChart } from "react-icons/bi";
import "./System.css";

interface UnclaimedSystem {
  id: number;
  system_name: string;
  patient_name: string;
  status: string;
  battery_lvl: number;
  charge_status: boolean;
  claimedby: string | null;
  network_type?: string;
  remote_session?: string;
  moveSystemToDashboard: (id: number) => void;
}

const UnclaimedSystem: React.FC<UnclaimedSystem> = ({
  id,
  system_name,
  patient_name,
  status,
  network_type,
  remote_session,
  moveSystemToDashboard,
}) => {
  const isOffline = status === "Offline";

  const onlineIcon = () => {
    if (network_type === "cellular") return <BiSignal5 size={18} color="#16a34a" />;
    if (network_type === "ethernet") return <BiNetworkChart size={18} color="#16a34a" />;
    return <BiWifi size={18} color="#16a34a" />;
  };

  // Section header in the parent handles study-vs-no-study differentiation;
  // here we just show patient name as primary when present, otherwise the
  // system name takes the primary slot.
  const hasStudy = !!patient_name?.trim();

  const remoteToolTag = () => {
    if (remote_session === "teamviewer") return "TV";
    if (remote_session === "gotomypc") return "G2";
    return null;
  };

  // Offline + no study = truly idle (no presence, no patient). Visually
  // dim instead of using the red offline treatment so operators can scan
  // past them. Offline with a study still gets the red treatment since
  // there's an active patient that's now unreachable — operator should
  // notice that.
  const isDim = isOffline && !hasStudy;

  return (
    <div className={`us-row${isOffline ? (isDim ? " us-row-dim" : " us-row-offline") : ""}`}>
      <div className="us-row-icon">
        {isOffline ? (
          <BiWifiOff size={18} color={isDim ? "#9ca3af" : "#dc2626"} />
        ) : (
          onlineIcon()
        )}
      </div>
      <div className="us-row-label">
        <div className="us-row-primary">
          {hasStudy ? patient_name : system_name}
        </div>
        {hasStudy && (
          <div className="us-row-secondary">
            {system_name}
            {remoteToolTag() && <span className="us-row-tool">{remoteToolTag()}</span>}
          </div>
        )}
        {!hasStudy && remoteToolTag() && (
          <div className="us-row-secondary">
            <span className="us-row-tool">{remoteToolTag()}</span>
          </div>
        )}
      </div>
      <button
        className={`us-row-claim${isOffline && !isDim ? " offline" : ""}${isDim ? " dim" : ""}`}
        onClick={() => moveSystemToDashboard(id)}
      >
        Claim
      </button>
    </div>
  );
};

export default UnclaimedSystem;
